import { render } from "./SortingTask.vue?vue&type=template&id=74e0920a"
import script from "./SortingTask.vue?vue&type=script&lang=js"
export * from "./SortingTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__